import { createContext } from "react";
import { CashInAndOutMethod } from "types";
import { MenuProps } from "types/menu";


export const MenuContext = createContext<{
    menuState: MenuProps;
    setMenuState: (menu: ((menuT: MenuProps) => MenuProps)) => void;
}>({
    menuState: {
        openItem: [],
        selectedID: null,
    },
    setMenuState: (menu: ((menuT: MenuProps) => MenuProps)) => {
    }
});

export type CashInCashDetailsType = {
    amount: string;
    method: CashInAndOutMethod;
};

export type CashoutDetailsType = {
    amountWithdrawn: string;
    fees: string;
    totalAmount: string;
    method: CashInAndOutMethod
};
